/* eslint-disable no-param-reassign */
import NotificationApi from '@/services/notifications';

const state = {
  notificationSettings: [],
};

const getters = {
  notificationSettings: currentState => currentState.notificationSettings,
};

const actions = {
  getNotificationSettings: async ({ commit }) => {
    try {
      const notificationSettings = await NotificationApi.getNotificationSettings();
      const objNew = [];
      const topics = (notificationSettings !== undefined
        && notificationSettings !== null
        && notificationSettings.length)
        ? notificationSettings
          .reduce((x, y) => (
            x.findIndex(e => e.topic === y.topic) < 0 ? [...x, y] : x), [])
        : [];

      if (topics.length) {
        topics.forEach((topic) => {
          const channel = notificationSettings
            .filter(notification => notification.topic === topic.topic);
          const channelMap = channel.map(el => ({
            idtAffNotification: el.idtAffNotification,
            desChannel: el.channel,
            status: el.indStatus,
          }));
          // eslint-disable-next-line no-const-assign
          objNew.push({
            topic: topic.topic,
            channel: channelMap,
          });
        });
      }
      commit('setNotificationsSettings', objNew);
    } catch (err) {
      console.error(err);
    }
  },
  disableNotification: async ({ commit }, notifications) => {
    try {
      await NotificationApi.changeNotificationStatus(notifications);
      commit('setDisabledNotification', notifications);
    } catch (err) {
      console.error(err);
    }
  },
  disableNotificationByChannel: async ({ commit }, element) => {
    try {
      await NotificationApi.changeNotificationStatus(element);
      commit('setDisabledNotificationByChannel', element);
    } catch (err) {
      console.error(err);
    }
  },
};

const mutations = {
  setDisabledNotification: (currentState, notification) => {
    currentState.notificationSettings.forEach((el) => {
      if (el.idtAffNotification === notification.idtAffNotification) {
        el.indStatus = !notification.status;
      }
    });
  },
  setDisabledNotificationByChannel: (currentState, element) => {
    currentState.notificationSettings.forEach((el) => {
      if (el.idtAffNotification === element.idtAffNotification
        && el.channel === element.desChannel) {
        el.indStatus = element.status;
      }
    });
  },
  setNotificationsSettings: (currentState, notificationSettings) => {
    currentState.notificationSettings = notificationSettings;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
